/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserImageRatings = /* GraphQL */ `
  mutation CreateUserImageRatings(
    $input: CreateUserImageRatingsInput!
    $condition: ModelUserImageRatingsConditionInput
  ) {
    createUserImageRatings(input: $input, condition: $condition) {
      s3_img_path
      user_id
      rating_overall
      rating_canopy
      rating_vine
      rating_fruit
      user {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userInfoRatingsUser_id
      __typename
    }
  }
`;
export const updateUserImageRatings = /* GraphQL */ `
  mutation UpdateUserImageRatings(
    $input: UpdateUserImageRatingsInput!
    $condition: ModelUserImageRatingsConditionInput
  ) {
    updateUserImageRatings(input: $input, condition: $condition) {
      s3_img_path
      user_id
      rating_overall
      rating_canopy
      rating_vine
      rating_fruit
      user {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userInfoRatingsUser_id
      __typename
    }
  }
`;
export const deleteUserImageRatings = /* GraphQL */ `
  mutation DeleteUserImageRatings(
    $input: DeleteUserImageRatingsInput!
    $condition: ModelUserImageRatingsConditionInput
  ) {
    deleteUserImageRatings(input: $input, condition: $condition) {
      s3_img_path
      user_id
      rating_overall
      rating_canopy
      rating_vine
      rating_fruit
      user {
        user_id
        group_id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        clientOrgInfoUsersGroup_id
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      userInfoRatingsUser_id
      __typename
    }
  }
`;
export const createClientOrgInfo = /* GraphQL */ `
  mutation CreateClientOrgInfo(
    $input: CreateClientOrgInfoInput!
    $condition: ModelClientOrgInfoConditionInput
  ) {
    createClientOrgInfo(input: $input, condition: $condition) {
      group_id
      is_vmc
      is_multi_vineyard
      users {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateClientOrgInfo = /* GraphQL */ `
  mutation UpdateClientOrgInfo(
    $input: UpdateClientOrgInfoInput!
    $condition: ModelClientOrgInfoConditionInput
  ) {
    updateClientOrgInfo(input: $input, condition: $condition) {
      group_id
      is_vmc
      is_multi_vineyard
      users {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteClientOrgInfo = /* GraphQL */ `
  mutation DeleteClientOrgInfo(
    $input: DeleteClientOrgInfoInput!
    $condition: ModelClientOrgInfoConditionInput
  ) {
    deleteClientOrgInfo(input: $input, condition: $condition) {
      group_id
      is_vmc
      is_multi_vineyard
      users {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo(
    $input: CreateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    createUserInfo(input: $input, condition: $condition) {
      user_id
      group_id
      group {
        group_id
        is_vmc
        is_multi_vineyard
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ratings {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      clientOrgInfoUsersGroup_id
      __typename
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo(
    $input: UpdateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    updateUserInfo(input: $input, condition: $condition) {
      user_id
      group_id
      group {
        group_id
        is_vmc
        is_multi_vineyard
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ratings {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      clientOrgInfoUsersGroup_id
      __typename
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo(
    $input: DeleteUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    deleteUserInfo(input: $input, condition: $condition) {
      user_id
      group_id
      group {
        group_id
        is_vmc
        is_multi_vineyard
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ratings {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      clientOrgInfoUsersGroup_id
      __typename
    }
  }
`;
